
import React from 'react';

export const ArrowDownRightIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    south_east
  </span>
);